import { render } from "./RightPaymentTable.vue?vue&type=template&id=43c70458&scoped=true"
import script from "./RightPaymentTable.vue?vue&type=script&lang=ts"
export * from "./RightPaymentTable.vue?vue&type=script&lang=ts"

import "./RightPaymentTable.vue?vue&type=style&index=0&id=43c70458&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43c70458"

export default script